import { CardImageWrapper } from './styles';
import { CardImageProps } from './types';

export const CardImage = ({ children, ...imageProps }: CardImageProps) => {
  // Callers spread a DatoCMS responsive-image object that also carries fields
  // which aren't valid <img> attributes (e.g. `webpSrcSet`, `aspectRatio`,
  // `base64`). Forward only the standard image attributes so React doesn't warn
  // about unrecognized DOM props.
  const { src, srcSet, sizes, width, height, alt, title } = imageProps;

  return (
    <CardImageWrapper>
      {children}
      {src && <img src={src} srcSet={srcSet} sizes={sizes} width={width} height={height} alt={alt} title={title} />}
    </CardImageWrapper>
  );
};
